// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSunday as fn } from "../isSunday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSundayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSundayWithOptions;
